/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _typeof } from './dep-e9b62d1f.js';
import './dep-c3f1141e.js';

function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

export { isObject_1 as i };
//# sourceMappingURL=dep-88cd50bf.js.map
